@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../constants/spacing.module.less';

@remover-width: 12px;
@remover-margin: 4px;
@remover-with-margin: @remover-width + @remover-margin + @remover-margin;

.action-editor {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  background-color: @settings-page--automation-rules-action-editor--background-color;
  border-radius: 4px;
  .remover {
    padding: 0;
    display: flex;
    align-items: flex-start;
  }
}

.skip-reprocess-checkbox {
  width: 100%;
  padding: 0 @space-8 @space-8;
}

.action-editor:has(.skip-reprocess-checkbox) {
  padding-bottom: 8px;
}

.highlighted-template-input {
  outline: 1px solid var(--blue-500);
}

.action-properties {
  display: grid;
  grid-template-columns: 50% 50%;
  width: calc(100% ~'-' @remover-with-margin);
  > div {
    padding: 8px;
    display: flex;
    align-items: flex-start;
    &:last-of-type {
      padding-right: 0;
    }
  }
}

.action-remover {
  display: flex;
  height: @remover-width;
  width: @remover-width;
  min-width: @remover-width;
  margin: @remover-margin;
  cursor: pointer;
  .icon {
    color: @settings-page--automation-rules-action-remover--text-color;
    height: 100%;
    width: 100%;
  }
  &:hover {
    .icon {
      color: @settings-page--automation-rules-action-remover--hover--text-color;
    }
  }
}

.automation-rule-actions {
  padding: 10px 20px 0;
  font-size: 14px;
}

.actions-header {
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 10px;
  align-items: center;
}

.rule-badge {
  min-width: 40px;
}
